import React, { useEffect } from 'react'
import { Form } from 'antd'
import PropTypes from 'prop-types'
import TitleInput from 'view/component/form-items/title-input'
import ShortDescriptionInput from 'view/component/form-items/short-description-input'
import OrganisationSelect from 'view/component/form-items/article-org-select'
import CategorySelect from 'view/component/form-items/category-select'
import PublishedSelect from 'view/component/form-items/published-select'
import SpecialGroupSelect from 'view/component/form-items/article-special-group-select'
import Upload from 'view/component/form-items/upload'
import QlikUrlInput from 'view/component/form-items/qlik-url-input'
import UpdateFrequencySelect from 'view/component/form-items/update-frequency-select'
import UserTypeSelect from 'view/component/form-items/article-user-type-select'
import TagSelect from 'view/component/form-items/tag-select'
import Email from 'view/component/form-items/send-email-select'
import Draft from 'view/component/form-items/draft'

const defaultFormValues = { published: false, send_emails: 'false', special: false }

const DiscoveryForm = ({ discovery = defaultFormValues, form }) => {
  useEffect(() => {
    form.setFieldsValue(discovery)
  }, [discovery])

  return (
    <Form
      form={form}
      layout='vertical'
      onFieldsChange={(changedFields) => {
        if (changedFields[0].name[0] === 'category_uuid') {
          form.setFieldsValue({ organisation_uuids: [], special: false, tag_uuid: [], user_type_uuids: [] })
        }
        if (changedFields[0].name[0] === 'special') {
          form.setFieldsValue({ user_type_uuids: [] })
        }
      }}
    >
      <TitleInput />
      <QlikUrlInput />
      <ShortDescriptionInput />
      <CategorySelect />
      <OrganisationSelect />
      <SpecialGroupSelect />
      <UserTypeSelect />
      <TagSelect />
      <UpdateFrequencySelect />
      <PublishedSelect />
      <Draft />
      <Upload fileName={discovery.image_name} />
      <Email />
    </Form>
  )
}

DiscoveryForm.propTypes = {
  discovery: PropTypes.object,
  form: PropTypes.object
}

export default DiscoveryForm
